interface SkeletonProps {
  /** CSS width, e.g. '100%', '12rem'. */
  width?: string;
  /** CSS height, e.g. '1rem', '6rem'. */
  height?: string;
  className?: string;
}

/** A shimmering placeholder matching the shape of the content being loaded.
 *  Prefer several of these arranged like the real layout over a spinner:
 *  the page keeps its geometry and nothing jumps when data lands. */
export function Skeleton({ width = '100%', height = '1rem', className = '' }: SkeletonProps) {
  return (
    <span
      className={`ui-skeleton${className ? ` ${className}` : ''}`}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}

/** Rows of ghost cells shaped like the table that is about to render. */
export function TableSkeleton({ rows = 5, columns = 4 }: { rows?: number; columns?: number }) {
  return (
    <div className="ui-skeletonTable" role="status" aria-label="Loading">
      {Array.from({ length: rows }, (_, row) => (
        <div key={row} className="ui-skeletonTableRow">
          {Array.from({ length: columns }, (_, col) => (
            <Skeleton key={col} height="0.9rem" width={col === 0 ? '60%' : '80%'} />
          ))}
        </div>
      ))}
    </div>
  );
}
